import React, { useContext } from 'react'
import { Flex, Hide, Text } from 'pcln-design-system'
import TripDetailsBox from './TripDetailsBox'
import BootstrapDataContext from '../../context/BootstrapDataContext'

export default function BookingInfo({
  product,
  date,
  headline,
  subHeadline
}: {
  product: 'hotel' | 'flight' | 'car'
  date: string
  headline: string
  subHeadline: string
}) {
  const {
    customer: { firstName = '' }
  } = useContext(BootstrapDataContext)

  return (
    <Flex
      pt={['24px', 4]}
      pb={[3, 4]}
      px={[3, '24px']}
      flexDirection="column"
      justifyContent="center"
      width={[1, null, 1 / 3, null, 3 / 11]}
    >
      <Text
        fontSize={[3, null, null, 4, 5]}
        lineHeight={[1.4, null, null, null, 1.125]}
        fontWeight="bold"
        mb={2}
        color="text"
        className={firstName ? 'fs-mask' : ''}
      >
        {firstName ? `${firstName}, your` : 'Your '} trip is coming up!
      </Text>
      <Hide xs sm md lg>
        <Text fontSize={2} mb="24px">
          {date}
        </Text>
      </Hide>
      <TripDetailsBox
        product={product}
        headline={headline}
        subHeadline={subHeadline}
      />
    </Flex>
  )
}
